var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8 0H4.2C3.08609 0 2.0178 0.395088 1.23015 1.09835C0.442499 1.80161 0 2.75544 0 3.75V16.25C0 17.2446 0.442499 18.1984 1.23015 18.9017C2.0178 19.6049 3.08609 20 4.2 20H23.8C24.9139 20 25.9822 19.6049 26.7698 18.9017C27.5575 18.1984 28 17.2446 28 16.25V3.75C28 2.75544 27.5575 1.80161 26.7698 1.09835C25.9822 0.395088 24.9139 0 23.8 0ZM4.2 2.5H23.8C24.1713 2.5 24.5274 2.6317 24.7899 2.86612C25.0525 3.10054 25.2 3.41848 25.2 3.75L14 9.85L2.8 3.75C2.8 3.41848 2.9475 3.10054 3.21005 2.86612C3.4726 2.6317 3.8287 2.5 4.2 2.5ZM25.2 16.25C25.2 16.5815 25.0525 16.8995 24.7899 17.1339C24.5274 17.3683 24.1713 17.5 23.8 17.5H4.2C3.8287 17.5 3.4726 17.3683 3.21005 17.1339C2.9475 16.8995 2.8 16.5815 2.8 16.25V6.6L13.272 12.3125C13.4848 12.4222 13.7262 12.48 13.972 12.48C14.2178 12.48 14.4592 12.4222 14.672 12.3125L25.2 6.6V16.25Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOutline);
export default __webpack_public_path__ + "static/media/mail-outline.ff0e573cd8fbe4bd53bbfcb667465cc2.svg";
export { ForwardRef as ReactComponent };